module.exports = __webpack_public_path__ + "img/IMG_1842.e051d983.jpg";